import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function UpcomingIcon({ stroke = '#FEB06D' }: SimpleIconInterface) {
  return (
    <SimpleIcon fill="none" height="18" viewBoxDimensions="0 0 19 18" width="19">
      <path
        d="M10.2972 2.30029C13.4884 2.83654 15.9222 5.60554 15.9222 8.94904C15.9222 12.6773 12.9004 15.699 9.17219 15.699C5.82869 15.699 3.05969 13.2653 2.52344 10.074"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.52363 7.82462C2.59488 7.40087 2.70513 6.99212 2.85138 6.59912"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.868 3.74854C4.54025 4.01929 4.2395 4.32004 3.96875 4.64779"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.04581 2.30011C7.62206 2.37136 7.21256 2.48236 6.82031 2.62861"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.51981 5.25V9.29325H6.22656"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SimpleIcon>
  );
}
